module.exports = __webpack_public_path__ + "assets/92ecfb44fea1c629e47a93463df32a95.mp3";